import type { AgeBucket } from '@/types';

export const AGE_MID: Record<AgeBucket, number> = {
  '18-24': 21,
  '25-34': 29,
  '35-44': 39,
  '45-54': 49,
  '55-64': 59,
  '65-74': 69,
  '75+': 77,
};
